import { render } from "./MainMenuMobile.vue?vue&type=template&id=4b486f59&scoped=true"
import script from "./MainMenuMobile.vue?vue&type=script&lang=js"
export * from "./MainMenuMobile.vue?vue&type=script&lang=js"

import "./MainMenuMobile.vue?vue&type=style&index=0&id=4b486f59&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b486f59"]])

export default __exports__